var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-card', {
    staticClass: "pr-12 pl-12 pt-7 pb-7",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "bold"
  }, [_vm._v(" Login ")])]), _c('v-card-text', [_c('v-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.isFormValid,
      callback: function callback($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-Mail",
      "type": "mail",
      "rules": _vm.emailRules,
      "prepend-icon": "mdi-account-circle",
      "id": "mail"
    },
    model: {
      value: _vm.mail,
      callback: function callback($$v) {
        _vm.mail = $$v;
      },
      expression: "mail"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Passwort",
      "type": _vm.isPasswordVisible ? 'text' : 'password',
      "rules": _vm.required,
      "prepend-icon": "mdi-lock",
      "append-icon": _vm.isPasswordVisible ? 'mdi-eye' : 'mdi-eye-off',
      "id": "password"
    },
    on: {
      "click:append": function clickAppend($event) {
        _vm.isPasswordVisible = !_vm.isPasswordVisible;
      }
    },
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _vm.failure ? _c('h3', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.failureText) + " ")]) : _vm._e(), _c('div', {
    staticClass: "mt-5 mb-7"
  }, [_c('v-btn', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isFormValid,
      "type": "submit",
      "x-large": "",
      "block": "",
      "outlined": "",
      "data-test-login": ""
    }
  }, [_vm._v(" Einloggen ")])], 1), _c('v-btn', {
    staticClass: "backButton",
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.showForgotPasswordCard
    }
  }, [_vm._v(" Passwort vergessen? ")]), _vm.isBackToLoginResetVisible ? _c('v-btn', {
    staticClass: "backButton",
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.backToLoginReset
    }
  }, [_vm._v(" Zurück zum Passwort setzen ")]) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }